import { render, staticRenderFns } from "./CategoriesManager.vue?vue&type=template&id=0a0934f6&scoped=true"
import script from "./CategoriesManager.vue?vue&type=script&lang=js"
export * from "./CategoriesManager.vue?vue&type=script&lang=js"
import style0 from "./CategoriesManager.vue?vue&type=style&index=0&id=0a0934f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0934f6",
  null
  
)

export default component.exports